import { useWeb3React } from '@web3-react/core';
import { useEffect, useState, useCallback, useRef } from 'react';
import { BigNumber, utils } from 'ethers';
import { formatEtherBalance } from './utils/formattingUtils';

function useConnectedBalance(): {
    balanceBigNumber: BigNumber | null;
    balance: string | null;
    formattedBalance: string | null;
    fetchBalance: () => void;
} {
    const { account, library, chainId } = useWeb3React();

    const [balance, setBalance] = useState<BigNumber | null>(null);
    const balanceInFlightRef = useRef(false);

    const fetchBalance = useCallback(
        async function fetchBalance(): Promise<void> {
            try {
                balanceInFlightRef.current = true;
                const _balance: BigNumber = await library.getBalance(account);
                setBalance(_balance);
                balanceInFlightRef.current = false;
            } catch (e: $TSFixMe) {
                setBalance(null);
                balanceInFlightRef.current = false;
            }
        },
        [account, library]
    );

    useEffect(() => {
        if (account && library && !balanceInFlightRef.current) {
            fetchBalance();
        }
    }, [account, library, chainId, fetchBalance]);

    return {
        balanceBigNumber: balance,
        balance: balance ? utils.formatEther(balance) : null,
        formattedBalance: balance ? formatEtherBalance(balance) : null,
        fetchBalance,
    };
}

export { useConnectedBalance };
